<template>
  <!-- 开票发票列表 -->
  <div style="margin: 30px;width: auto">
    <el-table :data="form.detail"
              :key="true">
      <el-table-column type="index"
                       key="index"
                       label="序号">
      </el-table-column>

      <el-table-column prop="type"
                       key="type"
                       label="开票类型">
      </el-table-column>

      <el-table-column prop="project_id"
                       key="project_id"
                       label="项目名称/编号">
        <template slot-scope="scope">
          <template v-if="form.issued_type * 1 === 1">
            {{ scope.row.project_name }}/{{ scope.row.project_number }}
          </template>
          <template v-if="form.issued_type * 1 === 2">
            {{ scope.row.virtual_project.name }}/{{ scope.row.virtual_project.number }}
          </template>
        </template>
      </el-table-column>

      <el-table-column prop="complete_rate"
                       key="complete_rate"
                       label="项目完成率">
      </el-table-column>

      <el-table-column prop="do_number"
                       key="do_number"
                       label="DO/PO单号">
      </el-table-column>

      <el-table-column prop="budget"
                       key="budget"
                       label="项目预算">
        <template slot-scope="scope">
          {{ symbol }}{{ scope.row.budget | seperateThousandsToFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column prop="cost"
                       key="cost"
                       label="项目成本">
        <template slot-scope="scope">
          {{ symbol }}{{ scope.row.cost | seperateThousandsToFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column label="规格型号"
                       prop="spec"
                       key="spec">
      </el-table-column>

      <el-table-column label="单位"
                       prop="unit"
                       key="unit">
      </el-table-column>

      <el-table-column label="数量"
                       prop="quantity"
                       key="quantity">
        <template slot-scope="scope">
          <span>{{scope.row.quantity * 1 === 0 ? '' : scope.row.quantity}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="invoice_full_name"
                       key="invoice_full_name"
                       label="开票名称">
      </el-table-column>

      <!-- <el-table-column prop="tax_type"
                       key="tax_type"
                       label="开票金额依据">
        <template slot-scope="scope">
        <span v-for="item in options.tax_type"
              v-if="scope.row.tax_type === item.value">{{ item.label }}</span>
        </template>
      </el-table-column> -->

      <el-table-column prop="untaxed_amount"
                       key="untaxed_amount"
                       label="未税金额">
        <template slot-scope="scope">
          {{ symbol }}{{ scope.row.untaxed_amount | seperateThousandsToFixed(2) }}
        </template>
      </el-table-column>

      <el-table-column prop="tax_rate"
                       key="tax_rate"
                       label="税率">
        <template slot-scope="scope">
          {{ scope.row.tax_rate }}%
        </template>
      </el-table-column>

      <el-table-column prop="total"
                       key="total"
                       label="价税合计">
        <template slot-scope="scope">
          <span> {{ symbol }}{{ scope.row.total | seperateThousandsToFixed(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="report.name"
                       key="report.name"
                       label="文件名">
        <template slot-scope="scope">
          <el-button style="white-space: pre-wrap;"
                     type="text"
                     @click="downloadZipFile(scope.row)">
            {{ scope.row.report ? scope.row.report.name : '' }}
          </el-button>
        </template>
      </el-table-column>

      <template v-if="[6, 7].includes(form.status) && this.$route.query.from === 'approve' && !form.is_from_core">
        <el-table-column fixed="right"
                         label="操作"
                         key="operation"
                         width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.received_payment_status !== 2 && [1, 5].includes(Number(user.usertype))"
                       type="primary"
                       size="mini"
                       @click="openAssocDialog(scope.row)">关联回款
            </el-button>
          </template>
        </el-table-column>
      </template>

    </el-table>
    <el-row style="margin-top: 30px;">
      <el-col :span="4"
              :offset="15"
              class="col-center">未税金额总计：{{ symbol }} {{ noTaxAmount | seperateThousandsToFixed(2) }}
      </el-col>
      <el-col :span="4"
              class="col-center">价税合计总计：{{ symbol }} {{ withTaxAmount | seperateThousandsToFixed(2) }}
      </el-col>
      <el-col :span="1"
              class="col-center"></el-col>
    </el-row>
    <affiliated-return-dialog :visible="assocVisible"
                              :detailItemId="assocRowId"
                              @closeDialog="closeAssocDialog">
    </affiliated-return-dialog>
  </div>
</template>

<script>
import AffiliatedReturnDialog from './AffiliatedReturnDialog'

export default {
  components: {
    AffiliatedReturnDialog
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      options: state => state.invoiceApply.options,
    }),
    noTaxAmount () {
      return this.form.detail.reduce((total, current) => {
        return total + Number(current.untaxed_amount)
      }, 0)
    },
    withTaxAmount () {
      return this.form.detail.reduce((total, current) => {
        return total + Number(current.total)
      }, 0)
    },
  },
  data () {
    return {
      assocRowId: null,
      symbol: '￥',
      assocVisible: false,
    }
  },
  watch: {
    form: {
      immediate: true,
      handler () {
        this.setProjectBudget()
      }
    }
  },
  methods: {
    // 获取项目成本和项目预算
    setProjectBudget () {
      if (this.form.setProjectBudgetFinish) {
        return true
      }
      for (let i = 0; i < this.form.detail.length; i++) {
        this.$set(this.form.detail[i], 'budget', '')
        this.$set(this.form.detail[i], 'cost', '')
        this.$set(this.form.detail[i], 'complete_rate', '')

        if (this.form.detail[i].projectid) {
          request.common('getInvoiceProjectFinance', {id: this.form.detail[i].projectid}).then(({data}) => {
            this.$set(this.form.detail[i], 'budget', _.round(Number(data.total_budget), 2))
            this.$set(this.form.detail[i], 'cost', _.round(Number(data.cost), 2))
            this.$set(this.form.detail[i], 'complete_rate', _.round(Number(data.complete_rate), 2))
          })
        }
      }
      return true
    },
    // 弹出关联回款弹层
    openAssocDialog (row) {
      this.assocRowId = row.id
      this.assocVisible = true
    },
    // 关闭关联回款弹层
    closeAssocDialog (refresh = false) {
      this.assocVisible = false
      this.assocRowId = null
      if (refresh) {
        this.$router.go(0)
      }
    },
    downloadZipFile (row) {
      window.open(filter.ossHost(row.report.url))
    },
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceDetailsList.vue